export const defaultSize = 14;
export const defaultPaddingPx = 10;
export const defaultMarginPx = 10;
const defaultLineHeight = `18px`;

export const fontSize = `${defaultSize}`;
export const padding = `${defaultPaddingPx / defaultSize}`;
export const lineHeight = `${defaultLineHeight}`;
export const verticalRhythm = 1.2;
export const borderRadius = `3px`;
export const xsmall = 0.7;
export const small = 0.8;
export const medium = 1;
export const large = 1.2;
export const xlarge = 1.3;

export const fontSizeBase = 12;

export const fontWeightLight = 300;
export const fontWeightRegular = 400;
export const fontWeightSemiBold = 600;
export const fontWeightBold = 700;

export const smallPadding = `5px`;
export const defaultPadding = `${defaultPaddingPx}px`;
export const largePadding = `15px`;

export const defaultMargin = `${defaultMarginPx}px`;

export const fontFamily = `'Open Sans', 'Helvetica Neue UltraLight', 'Helvetica Neue', Helvetica, sans-serif`;

export const aspectRatio16x9 = `56.25%`;

export const zIndex = {
    assetLibrary: {
        info: 500,
        overlay: 510
    },
    sidebar: 4000,
    headerOverlay: 4001,
    headerDropdown: 4002,
    pageHeader: 4400,
    dropdown: 4500,
    modal: 5000,
    overlay: 5500,
    tooltip: 6000,
    loader: 8000,
    max: 100000000
};
